import { Hero as HeroComponent } from './Hero/Hero';

export const Hero = () => {
  return <HeroComponent />;
};